import { render } from "./NavATF.vue?vue&type=template&id=32270d56&scoped=true"
import script from "./NavATF.vue?vue&type=script&lang=js"
export * from "./NavATF.vue?vue&type=script&lang=js"

import "./NavATF.vue?vue&type=style&index=0&id=32270d56&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32270d56"]])

export default __exports__